/** Convites (SPEC-IDN-011).
 *
 * Duas das três chamadas são públicas: quem chega pelo link ainda não tem
 * sessão. Elas respondem `404` para link inexistente, vencido, revogado e já
 * aceito — a tela trata os quatro como um caso só, que é o que a API quis.
 */

import { http } from "@/lib/http";
import type { components } from "@/lib/api-types";

export type PapelConvidavel = "admin" | "manager" | "seller" | "viewer" | "auditor";

export const PAPEIS: { codigo: PapelConvidavel; nome: string; descricao: string }[] = [
  { codigo: "seller", nome: "Vendedor", descricao: "Cuida das próprias oportunidades" },
  { codigo: "manager", nome: "Gestor", descricao: "Enxerga e gerencia o time" },
  { codigo: "viewer", nome: "Somente leitura", descricao: "Consulta, sem alterar" },
  { codigo: "auditor", nome: "Auditoria", descricao: "Só a trilha e os relatórios" },
  { codigo: "admin", nome: "Administrador", descricao: "Tudo, inclusive configuração" },
];

export type NovoConvite = components["schemas"]["ConvidarRequest"];

export type ConviteEmitido = components["schemas"]["ConviteResponse"];

export type ConviteVisivel = components["schemas"]["ConviteVisivelResponse"];

export async function convidar(dados: NovoConvite): Promise<ConviteEmitido> {
  return http.post<ConviteEmitido>("/users/invitations", dados);
}

export async function consultarConvite(token: string): Promise<ConviteVisivel> {
  return http.get<ConviteVisivel>(`/invitations/${encodeURIComponent(token)}`);
}

/** A resposta real é `AuthResponse` inteiro: também traz `token_type`,
 * `user.email`/`email_verified`/`mfa_enabled` e `tenant.name`, que o tipo
 * antigo nunca declarava. Divergência por falta (não por conflito) — ver
 * relatório da migração. */
export type SessaoDoAceite = components["schemas"]["AuthResponse"];

export async function aceitarConvite(token: string, password: string): Promise<SessaoDoAceite> {
  return http.post<SessaoDoAceite>(`/invitations/${encodeURIComponent(token)}/accept`, {
    password,
  });
}

/** O endereço que a pessoa convidada vai abrir.
 *
 * Montado no cliente porque é ele quem sabe em que host está: a API serve duas
 * instâncias com domínios diferentes, e devolver o link pronto do servidor
 * exigiria ensiná-lo o domínio do front.
 */
export function linkDoConvite(token: string): string {
  return `${window.location.origin}/convite/${encodeURIComponent(token)}`;
}
